// extracted by mini-css-extract-plugin
export var icon = "_6e-1";
export var subtext = "_6e-0";